/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  GuestPrivsDTO,
  GuestPrivsDTOOptional,
  GuestPrivsDTOMetaI,
  GuestPrivsDTOTrackedI,
} from "./guest-privs-dto";
import { GuestPrivsDTOTracked, GuestPrivsDTOMeta } from "./guest-privs-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemOrderRef,
  LineItemOrderRefOptional,
  LineItemOrderRefMetaI,
  LineItemOrderRefTrackedI,
} from "./line-item-order-ref";
import {
  LineItemOrderRefTracked,
  LineItemOrderRefMeta,
} from "./line-item-order-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  MembershipInternal,
  MembershipInternalOptional,
  MembershipInternalMetaI,
  MembershipInternalTrackedI,
} from "./membership-internal";
import {
  MembershipInternalTracked,
  MembershipInternalMeta,
} from "./membership-internal";
// May contain unused imports in some cases
// @ts-ignore
import type {
  MembershipTypeRef,
  MembershipTypeRefOptional,
  MembershipTypeRefMetaI,
  MembershipTypeRefTrackedI,
} from "./membership-type-ref";
import {
  MembershipTypeRefTracked,
  MembershipTypeRefMeta,
} from "./membership-type-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonNameDTO,
  PersonNameDTOOptional,
  PersonNameDTOMetaI,
  PersonNameDTOTrackedI,
} from "./person-name-dto";
import { PersonNameDTOTracked, PersonNameDTOMeta } from "./person-name-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchasableState,
  PurchasableStateOptional,
  PurchasableStateMetaI,
  PurchasableStateTrackedI,
} from "./purchasable-state";
import {
  PurchasableStateTracked,
  PurchasableStateMeta,
} from "./purchasable-state";

/**
 *
 * @export
 * @interface MembershipDTO
 */
export interface MembershipDTOOptional extends MembershipInternalOptional {
  /**
   *
   * @type {boolean}
   * @memberof MembershipDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  tempID?: string;
  /**
   *
   * @type {number}
   * @memberof MembershipDTO
   */
  price?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof MembershipDTO
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof MembershipDTO
   */
  voidCloseId?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  endActive?: Date;
  /**
   *
   * @type {MembershipTypeRef}
   * @memberof MembershipDTO
   */
  membershipTypeId?: MembershipTypeRefOptional;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  temp?: string;
  /**
   *
   * @type {PersonNameDTO}
   * @memberof MembershipDTO
   */
  personId?: PersonNameDTOOptional;
  /**
   *
   * @type {LineItemOrderRef}
   * @memberof MembershipDTO
   */
  lineItemId?: LineItemOrderRefOptional;
  /**
   *
   * @type {Array<GuestPrivsDTO>}
   * @memberof MembershipDTO
   */
  guestPrivs?: GuestPrivsDTOOptional[];
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  typeAndExpirationString?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  programName?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  typeName?: string;
}

export interface MembershipDTO
  extends MembershipDTOOptional, MembershipInternal {
  /**
   *
   * @type {boolean}
   * @memberof MembershipDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  tempID?: string;
  /**
   *
   * @type {number}
   * @memberof MembershipDTO
   */
  price?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof MembershipDTO
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof MembershipDTO
   */
  voidCloseId?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  endActive?: Date;
  /**
   *
   * @type {MembershipTypeRef}
   * @memberof MembershipDTO
   */
  membershipTypeId: MembershipTypeRef;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  temp?: string;
  /**
   *
   * @type {PersonNameDTO}
   * @memberof MembershipDTO
   */
  personId: PersonNameDTO;
  /**
   *
   * @type {LineItemOrderRef}
   * @memberof MembershipDTO
   */
  lineItemId?: LineItemOrderRef;
  /**
   *
   * @type {Array<GuestPrivsDTO>}
   * @memberof MembershipDTO
   */
  guestPrivs?: GuestPrivsDTO[];
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  typeAndExpirationString?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  programName?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  typeName?: string;
}

export interface MembershipDTOTrackedI extends MembershipInternalOptional {
  /**
   *
   * @type {boolean}
   * @memberof MembershipDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof MembershipDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  tempID?: string;
  tempIDIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipDTO
   */
  price?: number;
  priceIsSet: boolean;
  /**
   *
   * @type {PurchasableState}
   * @memberof MembershipDTO
   */
  purchasableState?: PurchasableState;
  purchasableStateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  purchaseDate?: Date;
  purchaseDateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipDTO
   */
  voidCloseId?: number;
  voidCloseIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {MembershipTypeRef}
   * @memberof MembershipDTO
   */
  membershipTypeId?: MembershipTypeRefTrackedI;
  membershipTypeIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  temp?: string;
  tempIsSet: boolean;
  /**
   *
   * @type {PersonNameDTO}
   * @memberof MembershipDTO
   */
  personId?: PersonNameDTOTrackedI;
  personIdIsSet: boolean;
  /**
   *
   * @type {LineItemOrderRef}
   * @memberof MembershipDTO
   */
  lineItemId?: LineItemOrderRefTrackedI;
  lineItemIdIsSet: boolean;
  /**
   *
   * @type {Array<GuestPrivsDTO>}
   * @memberof MembershipDTO
   */
  guestPrivs?: GuestPrivsDTOTrackedI[];
  guestPrivsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  typeAndExpirationString?: string;
  typeAndExpirationStringIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  programName?: string;
  programNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipDTO
   */
  typeName?: string;
  typeNameIsSet: boolean;
}

transformDatesMap.set("MembershipDTO", function (model: MembershipDTO) {
  if (typeof model.purchaseDate == "string")
    model.purchaseDate = new Date(model.purchaseDate);
  if (typeof model.startActive == "string")
    model.startActive = new Date(model.startActive);
  if (typeof model.endActive == "string")
    model.endActive = new Date(model.endActive);
  const transformDatesmembershipTypeId =
    transformDatesMap.get("MembershipTypeRef");
  if (transformDatesmembershipTypeId && model.membershipTypeId) {
    transformDatesmembershipTypeId(model.membershipTypeId);
  }
  const transformDatespersonId = transformDatesMap.get("PersonNameDTO");
  if (transformDatespersonId && model.personId) {
    transformDatespersonId(model.personId);
  }
  const transformDateslineItemId = transformDatesMap.get("LineItemOrderRef");
  if (transformDateslineItemId && model.lineItemId) {
    transformDateslineItemId(model.lineItemId);
  }
  const transformDatesguestPrivs = transformDatesMap.get("GuestPrivsDTO");
  if (transformDatesguestPrivs) {
    model.guestPrivs?.forEach((sub) => {
      transformDatesguestPrivs(sub);
    });
  }
});

export type MembershipDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  price: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  purchasableState: PropertyMeta<PurchasableStateMetaI>;
  //isDate: false
  //isDatetime: true
  purchaseDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  voidCloseId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  membershipTypeId: PropertyMeta<MembershipTypeRefMetaI>;
  //isDate: false
  //isDatetime: false
  temp: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonNameDTOMetaI>;
  //isDate: false
  //isDatetime: false
  lineItemId: PropertyMeta<LineItemOrderRefMetaI>;
  //isDate: false
  //isDatetime: false
  guestPrivs: PropertyMeta<GuestPrivsDTOMetaI>;
  //isDate: false
  //isDatetime: false
  typeAndExpirationString: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  programName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  typeName: PropertyMeta<MetaTypeBase<string>>;
}>;

export var MembershipDTOMeta: MembershipDTOMetaI = {} as MembershipDTOMetaI;
MembershipDTOMeta = typeMeta("MembershipDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
  price: propertyMeta("price", false, false, false, MetaTypesBase.number),
  purchasableState: propertyMeta(
    "purchasableState",
    false,
    false,
    false,
    PurchasableStateMeta,
  ),
  purchaseDate: propertyMeta(
    "purchaseDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  voidCloseId: propertyMeta(
    "voidCloseId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  startActive: propertyMeta(
    "startActive",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  endActive: propertyMeta("endActive", false, false, false, MetaTypesBase.Date),
  membershipTypeId: propertyMeta(
    "membershipTypeId",
    false,
    true,
    false,
    MembershipTypeRefMeta,
  ),
  temp: propertyMeta("temp", false, false, false, MetaTypesBase.string),
  personId: propertyMeta("personId", false, true, false, PersonNameDTOMeta),
  lineItemId: propertyMeta(
    "lineItemId",
    false,
    false,
    false,
    LineItemOrderRefMeta,
  ),
  guestPrivs: propertyMeta("guestPrivs", true, false, false, GuestPrivsDTOMeta),
  typeAndExpirationString: propertyMeta(
    "typeAndExpirationString",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  programName: propertyMeta(
    "programName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  typeName: propertyMeta("typeName", false, false, false, MetaTypesBase.string),
});

const metaI = MembershipDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([MembershipInternalMeta]);
  metaI.isDeleted.inheritedFrom = MembershipInternalMeta.isDeleted;
  metaI.isNew.inheritedFrom = MembershipInternalMeta.isNew;
  metaI.assignId.inheritedFrom = MembershipInternalMeta.assignId;
  metaI.tempID.inheritedFrom = MembershipInternalMeta.tempID;
  metaI.price.inheritedFrom = MembershipInternalMeta.price;
  metaI.purchasableState.inheritedFrom =
    MembershipInternalMeta.purchasableState;
  metaI.purchaseDate.inheritedFrom = MembershipInternalMeta.purchaseDate;
  metaI.voidCloseId.inheritedFrom = MembershipInternalMeta.voidCloseId;
  metaI.startActive.inheritedFrom = MembershipInternalMeta.startActive;
  metaI.endActive.inheritedFrom = MembershipInternalMeta.endActive;
  metaI.membershipTypeId.inheritedFrom =
    MembershipInternalMeta.membershipTypeId;
  metaI.temp.inheritedFrom = MembershipInternalMeta.temp;
  metaI.personId.inheritedFrom = MembershipInternalMeta.personId;
  metaI.lineItemId.inheritedFrom = MembershipInternalMeta.lineItemId;
  metaI.guestPrivs.inheritedFrom = MembershipInternalMeta.guestPrivs;
});

export class MembershipDTOTracked
  extends MembershipInternalTracked
  implements MembershipDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  price__I?: number = undefined;
  priceIsSet: boolean = false;
  set price(v: undefined | number) {
    if (v !== undefined) {
      this.price__I = v;
      this.priceIsSet = true;
    } else {
      this.price__I = v || undefined;
      this.priceIsSet = false;
    }
    this.changeTracker = true;
  }
  get price() {
    return this.price__I;
  }
  purchasableState__I?: PurchasableState = undefined;
  purchasableStateIsSet: boolean = false;
  set purchasableState(v: undefined | PurchasableState) {
    if (v !== undefined) {
      this.purchasableState__I = v;
      this.purchasableStateIsSet = true;
    } else {
      this.purchasableState__I = v || undefined;
      this.purchasableStateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchasableState() {
    return this.purchasableState__I;
  }
  purchaseDate__I?: Date = undefined;
  purchaseDateIsSet: boolean = false;
  set purchaseDate(v: undefined | Date) {
    if (v !== undefined) {
      this.purchaseDate__I = v;
      this.purchaseDateIsSet = true;
    } else {
      this.purchaseDate__I = v || undefined;
      this.purchaseDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchaseDate() {
    return this.purchaseDate__I;
  }
  voidCloseId__I?: number = undefined;
  voidCloseIdIsSet: boolean = false;
  set voidCloseId(v: undefined | number) {
    if (v !== undefined) {
      this.voidCloseId__I = v;
      this.voidCloseIdIsSet = true;
    } else {
      this.voidCloseId__I = v || undefined;
      this.voidCloseIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get voidCloseId() {
    return this.voidCloseId__I;
  }
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  membershipTypeId__I?: MembershipTypeRefTracked = undefined;
  membershipTypeIdIsSet: boolean = false;
  set membershipTypeId(v: undefined | MembershipTypeRefTracked) {
    if (v !== undefined) {
      this.membershipTypeId__I = v;
      this.membershipTypeIdIsSet = true;
    } else {
      this.membershipTypeId__I = v || undefined;
      this.membershipTypeIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get membershipTypeId() {
    return this.membershipTypeId__I;
  }
  temp__I?: string = undefined;
  tempIsSet: boolean = false;
  set temp(v: undefined | string) {
    if (v !== undefined) {
      this.temp__I = v;
      this.tempIsSet = true;
    } else {
      this.temp__I = v || undefined;
      this.tempIsSet = false;
    }
    this.changeTracker = true;
  }
  get temp() {
    return this.temp__I;
  }
  personId__I?: PersonNameDTOTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonNameDTOTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  lineItemId__I?: LineItemOrderRefTracked = undefined;
  lineItemIdIsSet: boolean = false;
  set lineItemId(v: undefined | LineItemOrderRefTracked) {
    if (v !== undefined) {
      this.lineItemId__I = v;
      this.lineItemIdIsSet = true;
    } else {
      this.lineItemId__I = v || undefined;
      this.lineItemIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get lineItemId() {
    return this.lineItemId__I;
  }
  guestPrivs__I?: GuestPrivsDTOTracked[] = undefined;
  guestPrivsIsSet: boolean = false;
  set guestPrivs(v: undefined | GuestPrivsDTOTracked[]) {
    if (v !== undefined) {
      this.guestPrivs__I = v;
      this.guestPrivsIsSet = true;
    } else {
      this.guestPrivs__I = v || undefined;
      this.guestPrivsIsSet = false;
    }
    this.changeTracker = true;
  }
  get guestPrivs() {
    return this.guestPrivs__I;
  }
  typeAndExpirationString__I?: string = undefined;
  typeAndExpirationStringIsSet: boolean = false;
  set typeAndExpirationString(v: undefined | string) {
    if (v !== undefined) {
      this.typeAndExpirationString__I = v;
      this.typeAndExpirationStringIsSet = true;
    } else {
      this.typeAndExpirationString__I = v || undefined;
      this.typeAndExpirationStringIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeAndExpirationString() {
    return this.typeAndExpirationString__I;
  }
  programName__I?: string = undefined;
  programNameIsSet: boolean = false;
  set programName(v: undefined | string) {
    if (v !== undefined) {
      this.programName__I = v;
      this.programNameIsSet = true;
    } else {
      this.programName__I = v || undefined;
      this.programNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get programName() {
    return this.programName__I;
  }
  typeName__I?: string = undefined;
  typeNameIsSet: boolean = false;
  set typeName(v: undefined | string) {
    if (v !== undefined) {
      this.typeName__I = v;
      this.typeNameIsSet = true;
    } else {
      this.typeName__I = v || undefined;
      this.typeNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeName() {
    return this.typeName__I;
  }
  constructor(config?: MembershipDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.membershipTypeId?.setIds();

    this.personId?.setIds();

    this.lineItemId?.setIds();

    this.guestPrivs?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: MembershipDTOOptional,
    options?: AssignOptions,
  ): MembershipDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (config.price && this.priceApplyFilter(optionsRequired.filter)) {
      this.price = config.price;
      if (optionsRequired.unassign) this.priceIsSet = false;
      else this.priceIsSet = true;
    }
    if (
      config.purchasableState &&
      this.purchasableStateApplyFilter(optionsRequired.filter)
    ) {
      this.purchasableState = config.purchasableState;
      if (optionsRequired.unassign) this.purchasableStateIsSet = false;
      else this.purchasableStateIsSet = true;
    }
    if (
      config.purchaseDate &&
      this.purchaseDateApplyFilter(optionsRequired.filter)
    ) {
      this.purchaseDate = config.purchaseDate;
      if (optionsRequired.unassign) this.purchaseDateIsSet = false;
      else this.purchaseDateIsSet = true;
    }
    if (
      config.voidCloseId &&
      this.voidCloseIdApplyFilter(optionsRequired.filter)
    ) {
      this.voidCloseId = config.voidCloseId;
      if (optionsRequired.unassign) this.voidCloseIdIsSet = false;
      else this.voidCloseIdIsSet = true;
    }
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (
      config.membershipTypeId &&
      this.membershipTypeIdApplyFilter(optionsRequired.filter)
    ) {
      this.membershipTypeId = new MembershipTypeRefTracked(
        config.membershipTypeId,
        options,
      );
      if (optionsRequired.unassign) this.membershipTypeIdIsSet = false;
      else this.membershipTypeIdIsSet = true;
    }
    if (config.temp && this.tempApplyFilter(optionsRequired.filter)) {
      this.temp = config.temp;
      if (optionsRequired.unassign) this.tempIsSet = false;
      else this.tempIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonNameDTOTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (
      config.lineItemId &&
      this.lineItemIdApplyFilter(optionsRequired.filter)
    ) {
      this.lineItemId = new LineItemOrderRefTracked(config.lineItemId, options);
      if (optionsRequired.unassign) this.lineItemIdIsSet = false;
      else this.lineItemIdIsSet = true;
    }
    if (
      config.guestPrivs &&
      this.guestPrivsApplyFilter(optionsRequired.filter)
    ) {
      this.guestPrivs = config.guestPrivs?.map(
        (a) => new GuestPrivsDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.guestPrivsIsSet = false;
      else this.guestPrivsIsSet = true;
    }
    if (
      config.typeAndExpirationString &&
      this.typeAndExpirationStringApplyFilter(optionsRequired.filter)
    ) {
      this.typeAndExpirationString = config.typeAndExpirationString;
      if (optionsRequired.unassign) this.typeAndExpirationStringIsSet = false;
      else this.typeAndExpirationStringIsSet = true;
    }
    if (
      config.programName &&
      this.programNameApplyFilter(optionsRequired.filter)
    ) {
      this.programName = config.programName;
      if (optionsRequired.unassign) this.programNameIsSet = false;
      else this.programNameIsSet = true;
    }
    if (config.typeName && this.typeNameApplyFilter(optionsRequired.filter)) {
      this.typeName = config.typeName;
      if (optionsRequired.unassign) this.typeNameIsSet = false;
      else this.typeNameIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): MembershipDTOTrackedI {
    const cloned = {} as MembershipDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    if (
      this.priceIsSetDeep() &&
      this.priceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceIsSet = true;
      cloned.price = this.price;
    } else {
      //cloned.priceIsSet = false
    }
    if (
      this.purchasableStateIsSetDeep() &&
      this.purchasableStateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchasableStateIsSet = true;
      cloned.purchasableState = this.purchasableState;
    } else {
      //cloned.purchasableStateIsSet = false
    }
    if (
      this.purchaseDateIsSetDeep() &&
      this.purchaseDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchaseDateIsSet = true;
      cloned.purchaseDate = this.purchaseDate;
    } else {
      //cloned.purchaseDateIsSet = false
    }
    if (
      this.voidCloseIdIsSetDeep() &&
      this.voidCloseIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.voidCloseIdIsSet = true;
      cloned.voidCloseId = this.voidCloseId;
    } else {
      //cloned.voidCloseIdIsSet = false
    }
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.membershipTypeIdIsSetDeep() &&
      this.membershipTypeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.membershipTypeIdIsSet = true;
      cloned.membershipTypeId = this.membershipTypeId?.removeUnset(filter);
    } else {
      //cloned.membershipTypeIdIsSet = false
    }
    if (
      this.tempIsSetDeep() &&
      this.tempApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIsSet = true;
      cloned.temp = this.temp;
    } else {
      //cloned.tempIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.lineItemIdIsSetDeep() &&
      this.lineItemIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lineItemIdIsSet = true;
      cloned.lineItemId = this.lineItemId?.removeUnset(filter);
    } else {
      //cloned.lineItemIdIsSet = false
    }
    if (
      this.guestPrivsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.guestPrivsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.guestPrivsIsSet = true;
      cloned.guestPrivs = this.guestPrivs
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.guestPrivsIsSet = false
    }
    if (
      this.typeAndExpirationStringIsSetDeep() &&
      this.typeAndExpirationStringApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeAndExpirationStringIsSet = true;
      cloned.typeAndExpirationString = this.typeAndExpirationString;
    } else {
      //cloned.typeAndExpirationStringIsSet = false
    }
    if (
      this.programNameIsSetDeep() &&
      this.programNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.programNameIsSet = true;
      cloned.programName = this.programName;
    } else {
      //cloned.programNameIsSet = false
    }
    if (
      this.typeNameIsSetDeep() &&
      this.typeNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeNameIsSet = true;
      cloned.typeName = this.typeName;
    } else {
      //cloned.typeNameIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): MembershipDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    if (!this.priceApplyFilter(filter)) this.priceIsSet = false;

    if (!this.purchasableStateApplyFilter(filter))
      this.purchasableStateIsSet = false;

    if (!this.purchaseDateApplyFilter(filter)) this.purchaseDateIsSet = false;

    if (!this.voidCloseIdApplyFilter(filter)) this.voidCloseIdIsSet = false;

    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.membershipTypeIdApplyFilter(filter))
      this.membershipTypeIdIsSet = false;
    this.membershipTypeId?.unassignAll(filter);

    if (!this.tempApplyFilter(filter)) this.tempIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    if (!this.lineItemIdApplyFilter(filter)) this.lineItemIdIsSet = false;
    this.lineItemId?.unassignAll(filter);

    if (!this.guestPrivsApplyFilter(filter)) this.guestPrivsIsSet = false;

    this.guestPrivs?.forEach((a) => a.unassignAll(filter));
    if (!this.typeAndExpirationStringApplyFilter(filter))
      this.typeAndExpirationStringIsSet = false;

    if (!this.programNameApplyFilter(filter)) this.programNameIsSet = false;

    if (!this.typeNameApplyFilter(filter)) this.typeNameIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipDTOMeta.isDeleted,
      MembershipDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(MembershipDTOMeta.isNew, MembershipDTOMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipDTOMeta.assignId,
      MembershipDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipDTOMeta.tempID,
      MembershipDTOMeta,
      this.tempID,
      this,
    );
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  priceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(MembershipDTOMeta.price, MembershipDTOMeta, this.price, this);
  }
  priceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceIsSet && this.priceApplyFilter(filter)) return true;

    return false;
  }
  purchasableStateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipDTOMeta.purchasableState,
      MembershipDTOMeta,
      this.purchasableState,
      this,
    );
  }
  purchasableStateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchasableStateIsSet && this.purchasableStateApplyFilter(filter))
      return true;

    return false;
  }
  purchaseDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipDTOMeta.purchaseDate,
      MembershipDTOMeta,
      this.purchaseDate,
      this,
    );
  }
  purchaseDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchaseDateIsSet && this.purchaseDateApplyFilter(filter))
      return true;

    return false;
  }
  voidCloseIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipDTOMeta.voidCloseId,
      MembershipDTOMeta,
      this.voidCloseId,
      this,
    );
  }
  voidCloseIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.voidCloseIdIsSet && this.voidCloseIdApplyFilter(filter))
      return true;

    return false;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipDTOMeta.startActive,
      MembershipDTOMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipDTOMeta.endActive,
      MembershipDTOMeta,
      this.endActive,
      this,
    );
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  membershipTypeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipDTOMeta.membershipTypeId,
      MembershipDTOMeta,
      this.membershipTypeId,
      this,
    );
  }
  membershipTypeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.membershipTypeIdIsSet && this.membershipTypeIdApplyFilter(filter))
      return true;
    return this.membershipTypeId?.anySet(filter) == true;

    return false;
  }
  tempApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(MembershipDTOMeta.temp, MembershipDTOMeta, this.temp, this);
  }
  tempIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIsSet && this.tempApplyFilter(filter)) return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipDTOMeta.personId,
      MembershipDTOMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  lineItemIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipDTOMeta.lineItemId,
      MembershipDTOMeta,
      this.lineItemId,
      this,
    );
  }
  lineItemIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.lineItemIdIsSet && this.lineItemIdApplyFilter(filter)) return true;
    return this.lineItemId?.anySet(filter) == true;

    return false;
  }
  guestPrivsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipDTOMeta.guestPrivs,
      MembershipDTOMeta,
      this.guestPrivs,
      this,
    );
  }
  guestPrivsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.guestPrivsIsSet && this.guestPrivsApplyFilter(filter)) return true;

    return this.guestPrivs?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  typeAndExpirationStringApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipDTOMeta.typeAndExpirationString,
      MembershipDTOMeta,
      this.typeAndExpirationString,
      this,
    );
  }
  typeAndExpirationStringIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.typeAndExpirationStringIsSet &&
      this.typeAndExpirationStringApplyFilter(filter)
    )
      return true;

    return false;
  }
  programNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipDTOMeta.programName,
      MembershipDTOMeta,
      this.programName,
      this,
    );
  }
  programNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.programNameIsSet && this.programNameApplyFilter(filter))
      return true;

    return false;
  }
  typeNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      MembershipDTOMeta.typeName,
      MembershipDTOMeta,
      this.typeName,
      this,
    );
  }
  typeNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeNameIsSet && this.typeNameApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    if (this.priceIsSetDeep(filter)) return true;
    if (this.purchasableStateIsSetDeep(filter)) return true;
    if (this.purchaseDateIsSetDeep(filter)) return true;
    if (this.voidCloseIdIsSetDeep(filter)) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.membershipTypeIdIsSetDeep(filter)) return true;
    if (this.tempIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.lineItemIdIsSetDeep(filter)) return true;
    if (this.guestPrivsIsSetDeep(filter)) return true;
    if (this.typeAndExpirationStringIsSetDeep(filter)) return true;
    if (this.programNameIsSetDeep(filter)) return true;
    if (this.typeNameIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
